module.exports = __webpack_public_path__ + "img/title.6dd587dc.png";